

























































































import { Component, Vue } from "vue-property-decorator";
import { Command } from "@/lib/Command";
import { Policies } from "@/lib/Policies";
import { ValidationObserver, ValidationObserverInstance, ValidationProvider } from "vee-validate";
import PoliciesComponent from "./PoliciesComponent.vue";

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    PoliciesComponent,
  },
})
export default class CommandForm extends Vue {
  public formModel: Command;
  public dialog = false;

  constructor() {
    super();
    this.formModel = this.getDefault();
  }

  public getDefault(): Command {
    return new Command("!example", false, new Policies(), [""]);
  }

  public async Submit(): Promise<void> {
    if (await (this.$refs.observer as ValidationObserverInstance).validate()) {
      this.$store.commit("addCommand", this.formModel);
      this.Cancel();
    }
  }

  public Cancel(): void {
    this.formModel = this.getDefault();
    (this.$refs.observer as ValidationObserverInstance).reset();
    this.dialog = false;
  }

  public AddMessage(): void {
    this.formModel.messages.push("");
  }

  public RemoveMessage(index: number): void {
    this.formModel.messages = this.formModel.messages.filter(
      (_, i) => i != index
    );
  }
}
